<div class="mk-card fx">
  <p class="mk-muted" *ngIf="store.loadingGroups && !store.reportGroups">Loading the sales groups&hellip;</p>

  <ng-container *ngIf="store.reportGroups">
    <b class="fx-title">{{ title }}</b>
    <p class="mk-muted">
      <ng-container *ngIf="names.length > 1">{{ names.join(', ') }}. </ng-container>
      Refresh the groups from Sage to bring {{ names.length > 1 ? 'them' : 'it' }} in.
      <ng-container *ngIf="lastReadLabel">Last read from Sage: {{ lastReadLabel }}.</ng-container>
    </p>
    <p class="mk-muted" *ngIf="!syncEnabled">Sync is paused for this organisation, so Aivor can't read Sage right now.</p>
    <button
      type="button"
      class="btn-teal-gradient fx-use"
      [disabled]="store.refreshing || !syncEnabled"
      (click)="store.refreshGroups()"
    >
      {{ store.refreshing ? 'Refreshing…' : 'Refresh sales groups from Sage' }}
    </button>
    <div class="fx-status" *ngIf="store.refreshResult">
      <span>{{ store.refreshResult }}</span>
      <span *ngIf="names.length">Still not in Sage: {{ names.join(', ') }}.</span>
    </div>
  </ng-container>

  <div class="fx-list" *ngIf="offersAnotherGroup">
    <b class="fx-title">Choose another sales group for these items</b>
    <p class="mk-muted">Or add the group in Sage, then refresh again.</p>
    <app-sales-group-items [store]="store" [idPrefix]="idPrefix"></app-sales-group-items>
  </div>

  <p class="fx-error" role="alert" *ngIf="store.error">{{ store.error }}</p>
</div>
